<template>
  <div class="page border-box" v-wechat-title="$route.meta.title='团队预约'">
    <div class="alert-box alert-order border-box" v-if="orderShow==1">
      <div class="order-con border-box">
        <p style="font: bold .32rem 'Microsoft YaHei';color: #333;text-align: center;">四川博物院团体参观协议</p>
        <p style="margin-top:.24rem;font: .29rem/.46rem 'Microsoft YaHei';color: #333;">亲爱的观众：</p>
        <p style="margin-top:.16rem;font: .29rem/.46rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">欢迎来到四川博物院参观，为了给您提供良好的参观环境，现将团体参观事项提示如下，望您给予支持与配合，同时知悉以下几点:</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">1.四川博物院周一闭馆，每张团体票参观人数上限为600人/半天，1200人/全天，需至少提前1个工作日预约；<span style="color: red;">注：所有需要在馆内自行开展讲解（含社教）活动的团队均需提前3个工作日进行团队预约;</span></p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">2.预约提交后，请您留意界面中“我的预约”订单审核状态，审核通过即可凭此订单入馆。因故不能按时到馆，请提前拨打咨询电话，取消订单；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">3.团体观众入馆和离馆集合地为北门广场，请勿在展厅内整队集合；团体参观需领队人员凭预约订单入馆，团员不得分散入馆。</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">4.为保证展厅安全和参观质量，每次进馆人数不得超过200人，且必须配备安全秩序员，确保参观秩序和安全；如果超过200人，需分批次进馆参观。团队负责人需组织好团队成员文明有序观展，每个展厅一次性团体参观人数建议不超过50人；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">5.团队预约前组织者需确定参观人员身体健康、情绪稳定，适宜参观，参观中由团体成员引起的突发事件和安全事故由团体和责任人自行承担；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">6.学生团队参观前，须进行必要的安全行为培训，并配备足够的教师及监护人陪同参观，学校、教师及监护人对学生的安全和行为负全责；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">7.在开展讲解和社会教育活动时：</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(1)请勿在展厅使用扩音设备；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(2)请勿嘻戏打闹、追逐奔跑；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(3)请勿大声喧哗；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(4)请勿触摸展品；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(5)请勿将食物及饮品带入展厅；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(6)请勿在展厅内席地而坐、长时间停留写生、授课等；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .66rem;">(7)请勿随意丢弃垃圾。</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">8.团体参观者需遵守四川博物院参观规定，若参观者在院内有任何违反相关规定的行为，本院工作人员有权进行制止，若不听劝阻，本院工作人员有权要求其终止活动并劝离；</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">9.预约审核时间为9:00-17:00。</p>
        <p style="margin-top:.24rem;font: .28rem/.42rem 'Microsoft YaHei';color: #333;text-indent: .56rem;">咨询电话：<a href="tel:028-65521888" style="color: #0b97c4;">028-65521888</a>、<a href="tel:028-65521888" style="color: #0b97c4;">028-65521569</a></p>
        <font style="color: #fa4f45;"></font>
      </div>
      <div class="btn-box border-box">
        <div class="btn linear" :class="ruletime>0?'disabled':''" @click="closeFun">我已阅读，同意预约<font v-if="ruletime>0">{{ruletime}}s</font></div>
      </div>
    </div>

    <div v-else>
      <div>
        <div class="time-box border-box"  v-for="(item,index) in timeList" :key="index">
          <span class="close" @click="delItem(item,index)" v-if="index>0"></span>
          <div class="item">
            <p class="tit"><span>*</span>参观日期</p>
            <div class="item-inp border-box">
              <input type="text" placeholder="请选择参观日期" readonly v-model="item.dtxt" @click="openDayPicker(index)">
            </div>
          </div>
          <div class="item" v-if="item.did">
            <p class="tit"><span>*</span>参观时段</p>
            <div class="item-inp border-box">
              <input type="text" placeholder="请选择参观时段" readonly  v-model="item.ttxt" @click="openTimePicker(index)">
            </div>
          </div>
          <div class="item">
            <p class="tit"><span>*</span>参观人数</p>
            <div class="item-inp border-box">
              <input type="number" placeholder="请填写参观人数" v-model="item.people">
            </div>
          </div>
        </div>
      </div>

      <div class="add-btn" @click="addItem" v-if="timeList.length<5">添加时段</div>

      <p class="com-info">参观单位信息</p>

      <div class="item">
        <p class="tit"><span>*</span>单位名称</p>
        <div class="item-inp border-box">
          <input type="text" placeholder="请填写参观单位名称" v-model="reportInfo.team"  v-on:input="bindInput()">
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>是否在馆内自行开展讲解和社教活动</p>
        <div class="item-inp border-box item-inp1">
          <span class="radio" :class="reportInfo.isguide==0?'curr':''" @click="isguideClick(0)">否</span>
          <span class="radio" :class="reportInfo.isguide==1?'curr':''" @click="isguideClick(1)">是</span>
        </div>
        <p class="border-box" style="padding-left:.12rem;font: .24rem/.42rem 'Microsoft YaHei';color: #fd811e;">温馨提示：如需开展，请领队人员前往前台办理相关手续，领取证件方可开展相关活动！禁止在馆内外拉客揽客，一经发现，涉事单位和个人列入馆方“黑名单”。</p>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>经办人姓名</p>
        <div class="item-inp border-box">
          <input type="text" placeholder="请填写经办人姓名" v-model="reportInfo.name"  v-on:input="bindInput()">
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>经办人电话</p>
        <div class="item-inp border-box">
          <input type="tel" placeholder="请填写经办人电话" v-model="reportInfo.phone"  v-on:input="bindInput()">
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>经办人身份证照片</p>
        <div class="item-img">
          <div class="img-box">
            <img class="img tx" :src="idImg?((typeof idImg === 'string')?idImg:idImg.result):require('../../assets/icon-add1.jpg')" alt="" style="object-fit: contain;">
            <input type="file" name="file" @change="fileUpload($event,'img',1)" accept="image/*" enctype="multipart/form-data">
          </div>
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>上传介绍信(需加盖公章)
          <a class="fr" style="color: #0b97c4;font-size: .26rem;" href="https://jpjs.geeker.com.cn/dist/cbtourist/static/xin.docx" target="blank">+模板下载</a>
        </p>
        <!-- <p class="border-box" style="padding: .16rem .24rem 0;font: 0.24rem/0.36rem 'Microsoft YaHei';color: #fd811e;">温馨提示：请上传不低于200KB大小的清晰图片，无法识别的图片将会被拒绝！</p> -->
        <p class="border-box" style="padding: .16rem .24rem 0;font: 0.24rem/0.36rem 'Microsoft YaHei';color: #fd811e;">温馨提示：1.请上传不低于200KB大小的清晰图片，无法识别的图片将被系统自动拒绝。2.当天带队导游如有多名，请在介绍信中如实填写信息。一封介绍信最多填写三名带队导游。一人一证，如信息不符，将不予换证。</p>
        <div class="item-img">
          <div class="img-box img-box1">
            <!--<p v-if="xinImg">{{xinImg.name}}</p>-->
            <!--<img class="img tx" src="../../assets/icon-add1.jpg" alt="" v-else  style="object-fit: contain;">-->
            <!--<input type="file" name="file" @change="fileUpload($event,'file')" accept="application/msword" enctype="multipart/form-data">  文件传输-->

            <img class="img tx" :src="xinImg?((typeof xinImg === 'string')?xinImg:xinImg.result):require('../../assets/icon-add1.jpg')" alt="" style="object-fit: contain;">
            <input type="file" name="file" @change="fileUpload($event,'img',2)" accept="image/*" enctype="multipart/form-data">
          </div>
          <!--<input type="tel" placeholder="请填写经办人电话">-->
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>请选择上传的证件类型:</p>
        <div class="item-inp border-box item-inp1" style="height: auto;">
          <div class="radio" :class="reportInfo.zjtype==1?'curr':''" @click="isZjtypeClick(1)">营业执照</div>
          <div class="radio" :class="reportInfo.zjtype==2?'curr':''" @click="isZjtypeClick(2)">其他</div>
        </div>
        <p class="border-box" style="padding: .16rem .24rem 0;font: 0.24rem/0.36rem 'Microsoft YaHei';color: #fd811e;">温馨提示：证件类型不是营业执照，例如“事业单位法人证书”、“经营许可证”等证件类型，请选择“其他”！</p>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>{{reportInfo.zjtype==1?'营业执照图片':'证件图片'}}</p>
        <div class="item-img">
          <div class="img-box">
            <img class="img tx" :src="zzImg?((typeof zzImg === 'string')?zzImg:zzImg.result):require('../../assets/icon-add1.jpg')" alt="" style="object-fit: contain;">
            <input type="file" name="file" @change="fileUpload($event,'img',3)" accept="image/*" enctype="multipart/form-data">
          </div>
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>单位名称</p>
        <div class="item-inp border-box">
          <input type="text" placeholder="单位名称自动识别填充" v-bind:readOnly="inpReadonly" v-model="reportInfo.cname" v-if="reportInfo.zjtype==1">
          <input type="text" placeholder="请输入单位名称" v-model="reportInfo.cname" v-if="reportInfo.zjtype==2">
        </div>
      </div>
      <div class="item">
        <p class="tit"><span>*</span>{{reportInfo.zjtype==1?'社会信用代码':'编号'}}</p>
        <div class="item-inp border-box">
          <input type="tel" placeholder="社会信用代码自动识别填充" v-bind:readOnly="inpReadonly" v-model="reportInfo.snum" v-if="reportInfo.zjtype==1">
          <input type="tel" placeholder="请输入编号" v-model="reportInfo.snum" v-if="reportInfo.zjtype==2">
        </div>
      </div>
      <p class="border-box" style="padding:.24rem;font: 0.24rem/0.36rem 'Microsoft YaHei';color: #fd811e;">温馨提示：团队门票预约不含讲解预约，如需官方讲解服务，请在公众号上另行预约。</p>
      <!--<div class="item">-->
      <!--<p class="tit">备注信息</p>-->
      <!--<textarea class="border-box" name="" id="" placeholder="请填写备注信息" v-model="reportInfo.note"  v-on:input="bindInput()"></textarea>-->
      <!--</div>-->
      <div class="btn linear" @click="submitFun">立即预约</div>
    </div>

    <div class="menu border-box" @click="toTeamList">我的<br>预约</div>


    <Picker :pickerData="pickerData" :pickertitle="pickertitle" @sendObj="getPickerData" v-if="pickerShow==1"></Picker>


    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>
<script>
  import P400 from '../../components/P400'
  import Picker from '../../components/Picker'
  import {getTeamDate, getDatePeople, getTeamReport, getYyzzocr} from "@/service/getData";
  import {wxGetPosition,wxShareme,uploadFile,uploadFile1} from '@/utils/wechat'
  import {setStore, getStore, removeStore, getWeekname} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)
  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        scenicId: this.$route.query.scenicId || '', //景区id
        scenicKey: this.$route.query.scenicKey || '', //来源标记
        name:'',//经办人姓名
        team:'',//单位名称

        phone:'',//经办人电话
        idImg:'',//身份证
        xinImg:'',//介绍信
        zzImg:'',//营业执照
        cname:'',//公司名称
        snum:'',//社会信用代码
        note:'',//备注信息
        P400: 0, //系统维护中
        date: '', //时间筛选
        timeCurr:'',//选择时段
        timeAlertShow:0,//时段弹窗显示与隐藏
        calendarShow:0,//日历弹窗显示与隐藏

        timeList:[
          {date:'', time:'', people: '', did: '', tid: '', dtxt: '', ttxt: ''}
        ],//参观时段数据  [{   "tid":"时段列表id","people":"人数"}]
        currInd:'', //操作时段下标

        nearDaysList:[],//近7日
        timeSdList:[], //某一天的时间段


        ruletime: 5, //type=='rule'时，倒计时
        orderShow: 1,
        getWeekname: getWeekname,
        pickerShow: 0, //是否显示单项选择器弹窗

        reportInfo: {
          isguide: 0, //是否需要导游
        }, //需要提交的数据、回显数据
        inpReadonly:true,
//        zjtype:1,//证件类型1：营业执照 2：其他
      }
    },
    computed: {},

    created(){
      var self = this;
      var timer = setInterval(function(){
        self.ruletime--;
        if(self.ruletime<=0){
          clearInterval(timer);
          timer = null;
        }
      },1000);

      this.reportInfo = getStore("reportInfo",1) || {isguide: 0};
      if(this.reportInfo && this.reportInfo.msg){
        var msg = JSON.parse(this.reportInfo.msg)
        if(msg && msg.length>0){
          this.timeList = msg
        }
      }
      if(this.reportInfo && this.reportInfo.cardimg){
        this.idImg = this.reportInfo.cardimg;
      }
      if(this.reportInfo && this.reportInfo.tuiimg){
        this.xinImg = this.reportInfo.tuiimg;
      }
      if(this.reportInfo && this.reportInfo.yyimg){
        this.zzImg = this.reportInfo.yyimg;
      }

    },
    methods: {
      async getTeamDateFun(){
        let res = await getTeamDate({});
        if (res.errcode == "00000") {
          this.nearDaysList = res.data

          if(this.nearDaysList && this.nearDaysList.length>0){
            this.pickerClick('date','参观日期',this.nearDaysList)
          }else {
            this.$toast('暂无可预约参观日期')
          }


        }
      },
      async getDatePeopleFun(did){
        let res = await getDatePeople({
          id: did
        });
        if (res.errcode == "00000") {
          this.timeSdList = res.data

          if(this.timeSdList && this.timeSdList.length>0){
            this.pickerClick('time','参观时段',this.timeSdList)
          }else {
            this.$toast('暂无可预约参观时段')
          }
        }
      },

      //关闭用户协议弹窗
      closeFun:function(){
        if(this.ruletime<=0){
          this.orderShow = 0;
        }else{
          this.orderShow = 1;
        }
      },

      //添加参观时段
      addItem:function (){
        var self = this;
        var arr = {date:'',time:'',people: '', did: '', tid: '', dtxt: '', ttxt: ''};
        self.timeList.push(arr);
      },
      //删除某个参观时段
      delItem:function (item,index){
        this.timeList.splice(index,1);

      },

      //打开日期时间弹窗
      openDayPicker: function (index){
        this.currInd = index;
        this.getTeamDateFun();
      },
      //打开时间弹窗
      openTimePicker: function (index){
        this.currInd = index;
        this.getDatePeopleFun(this.timeList[this.currInd].did)
      },

      //点击弹出选择器
      pickerClick:function (pickerType,title, data){
        this.pickerType = pickerType;
        this.pickertitle = title;
        this.pickerData = data;
        this.pickerShow = 1;
      },
      //选择器选择结果后处理逻辑
      getPickerData: function (data){
        if(data.pickerShow || data.pickerShow===0){
          this.pickerShow = data.pickerShow;
        }
        console.log(data)
        if(this.pickerType=='date' && data.id){
          if(data.state==1){
            this.timeList[this.currInd].date = data.time;
            this.timeList[this.currInd].did = data.id;
            this.timeList[this.currInd].dtxt = data.txt;
            this.timeSdList = [];
            this.timeList[this.currInd].time = '';
            this.timeList[this.currInd].tid = '';
            this.timeList[this.currInd].ttxt = '';
          }else {
            this.$toast('所选日期不在接待日内')
          }
        }else if(this.pickerType=='time' && data.id){
          this.timeList[this.currInd].time = data.time;
          this.timeList[this.currInd].tid = data.id;
          this.timeList[this.currInd].ttxt = data.txt;
        }

        this.reportInfo.msg = JSON.stringify(this.timeList);
        setStore("reportInfo", this.reportInfo,1);
      },

      //默认需要讲解服务
      isguideClick: function (val){
        this.reportInfo['isguide'] = val;
        this.reportInfo = Object.assign({}, this.reportInfo);
      },

      //监听输入框
      bindInput: function (){
        setStore("reportInfo", this.reportInfo,1);
      },

      //选择症胶囊类型
      isZjtypeClick: function (val){
        this.reportInfo.cname = '';
        this.reportInfo.snum = '';
        this.reportInfo.yyimg = '';
        this.zzImg = '';
        this.reportInfo['zjtype'] = val;
        this.reportInfo = Object.assign({}, this.reportInfo);
      },
      //文件上传
      fileUpload: function(event,type,type1){
        var self = this;
        var file = event.target.files[0];

        console.log(file)
        var formData = new FormData();
        formData.append('Filedata', file);

        if(type=='img'){
          var fr = new FileReader();
          fr.readAsDataURL(file);
          fr.onload = function () {
            if(type1==1){ //身份证照片
              self.idImg = fr;
              uploadFile1(formData,function(res){
                self.reportInfo.cardimg = '';
                if(res.data.errcode == "00000"){
                  self.reportInfo.cardimg = res.data.url;
                  setStore("reportInfo", self.reportInfo,1);
                }else {
                  self.$toast('图片上传出错')
                }
              });
            }else if(type1==2){ //介绍信
              if(parseInt(file.size/1024)<200){
                self.$toast('请上传不低于200KB大小的清晰图片！');
                 return
              }else{
                self.xinImg = fr;
                uploadFile1(formData,function(res){
                  self.reportInfo.tuiimg = '';
                  if(res.data.errcode == "00000"){
//                    self.reportInfo.tuiimg = res.data.data.url;
                    self.reportInfo.tuiimg = res.data.url;
                    setStore("reportInfo", self.reportInfo,1);
                  }else {
                    self.$toast('图片上传出错')
                  }
                });
              }
            }else if(type1==3){ //营业执照
              self.zzImg = fr;
              uploadFile1(formData,function(res){
                self.reportInfo.cname = '';
                self.reportInfo.snum = '';
                self.reportInfo.yyimg = '';

                if(res.data.errcode == "00000"){
                  self.reportInfo.yyimg = res.data.url;
                  setStore("reportInfo", self.reportInfo,1);
                  if(self.reportInfo.zjtype==1){
                    self.$loading.show('识别中...');
                    self.getYyzzocrFun(res.data.url)
                  }
                }else {
                  self.$toast('图片上传出错')
                }
              });
            }
          };
//          this.reportInfo.cardimg = 'https://filewc.geeker.com.cn/test/base64_file/20220223/DmQ45fQU3BQ1fE2V8nK839G4zIQR29EjWC4cC7.png'
//          this.reportInfo.tuiimg = 'https://filewc.geeker.com.cn/test/base64_file/20220223/7xmfjem18OyfbRdj2B7InSaRqG2xTyx3JM61bz.png'


        }else if(type=='file'){
          self.xinImg = file;
          uploadFile1(formData,function(res){
            if(res.data.errcode == "00000"){
              self.reportInfo.tuiimg = res.data.url;
              setStore("reportInfo", self.reportInfo,1);
            }else {
              self.$toast('文件上传出错')
            }
          });
        }

      },

      //识别营业执照
      async getYyzzocrFun(img){
        let res = await getYyzzocr({
          img: img
        });
        if (res.errcode == "00000") {
          this.$loading.hide();
          this.reportInfo.cname = res.data.cname;
          this.reportInfo.snum = res.data.snum;
          this.$set(this.reportInfo);
          setStore("reportInfo", this.reportInfo,1);
        }else{
          this.$loading.hide();
//          this.zzImg = '';
          this.$alert({
            title: '提示',
            content: res.errmsg
          });
        }
      },


      //立即预约
      submitFun: function (){
        if(this.isSuccess){
          return;
        }
        this.isSuccess = true;

        console.log(this.reportInfo);
        var timeList=this.timeList;
        for(var i=0; i<timeList.length; i++){
          if(!timeList[i].did){
            this.$toast('请选择参观日期');
            this.isSuccess = false;
            return
          }else if(!timeList[i].tid){
            this.$toast('请选择参观时段');
            this.isSuccess = false;
            return
          }else if(!timeList[i].people){
            this.$toast('请填写参观人数');
            this.isSuccess = false;
            return
          }
//          else if(timeList[i].people<20){
//            this.$toast('团队预约参观人数需不少于20人');
//            this.isSuccess = false;
//            return
//          }
        }
        this.reportInfo.msg = JSON.stringify(timeList);


        if(!this.reportInfo.team){
          this.$toast('请填写单位名称');
          this.isSuccess = false;
          return
        }
        if(!this.reportInfo.name){
          this.$toast('请填写经办人姓名');
          this.isSuccess = false;
          return
        }
        if(!this.reportInfo.phone){
          this.$toast('请填写经办人电话');
          this.isSuccess = false;
          return
        }
        if(!this.reportInfo.cardimg){
          this.$toast('请上传经办人身份证照片');
          this.isSuccess = false;
          return
        }
        if(!this.reportInfo.tuiimg){
          this.$toast('请上传已加盖公章的介绍信');
          this.isSuccess = false;
          return
        }
        if(!this.reportInfo.yyimg){
          this.$toast('请上传营业执照/证件');
          this.isSuccess = false;
          return
        }
        this.$loading.show('信息提交中');

        this.getTeamReportFun();
      },

      //提交预约
      async getTeamReportFun(){
        this.userInfo = getStore("userInfo");
        this.reportInfo.openid = this.userInfo.openid;
        let res = await getTeamReport(this.reportInfo);
        if(res.errcode == "00000"){
          this.$loading.hide();
          this.$toast('预约成功');


          var timeList = [
            {date:'', time:'', people: '', did: '', tid: '', dtxt: '', ttxt: ''}
          ];
          this.reportInfo.msg = JSON.stringify(timeList);
          this.reportInfo.tuiimg = '';
          setStore("reportInfo", this.reportInfo,1);

          this.toTeamList();


        }else{
          this.$loading.hide();
          this.$alert({
            title: '提示',
            content: res.errmsg
          });
        }
        this.isSuccess = false;
      },

      toTeamList(){
        this.$router.push({
          path: `/order-team-list?${'scenicId='+this.scenicId+'&scenicKey='+this.scenicKey}`
        });
      },

    },
    watch: {},
    components: {
        P400,Picker
    }
  }

</script>

<style scoped>
  .page{min-height: 100vh; padding: .2rem .3rem 1.3rem;background-color:#fff;overflow-y: scroll;}
  .com-info{text-align: center;margin-top: .42rem;text-align: center;font-size: .32rem;font-weight: bold;color: #333;}
  .time-box{position:relative;width: 100%;padding: .24rem;margin-top:.12rem;background: #f3f3f3;border:1px solid #e3e3e3;border-radius: .08rem;}
  .time-box .close{position: absolute;right: -.1rem;top: -.1rem;width: .32rem;height: .32rem;background: url(../../assets/icon-close2.png) no-repeat center;background-size: 100% 100%;}
  .add-btn{display: block;width: 2rem;height: .56rem;margin:.24rem auto 0;text-align: center;color:#fff;font: .24rem/.56rem "Microsoft YaHei";border-radius: 0.08rem;background: #FF4F0D;}
  .item{margin-top: .24rem;}
  .item:first-child{margin-top: 0;}
  .item p{font: .28rem/.42rem "Microsoft YaHei";color: #333;}
  .item p span{color: #FF4F0D;}
  .item-inp{position:relative;width: 100%;height: .62rem;margin-top:.12rem;padding:.04rem .17rem;border-radius: .06rem;border: 1px solid #e3e3e3;background: #fff;}
  .item-inp input{display: inline-block;width: 100%;height: 100%;font: .26rem/.44rem "Microsoft YaHei";color: #333;}
  .btn{position:fixed;bottom:0;left:0;z-index: 11;width:100%; height: .88rem; line-height: .88rem;border-radius: 0;font-size: .3rem;}
  .item-img .img-box{position:relative;width: 90%;height: auto;margin:.2rem auto 0;border-radius: .12rem;overflow: hidden;}
  .item-img .img-box .tx{border-radius: 0.12rem;overflow: hidden;}
  .item-img .img-box1 p{position:relative;width: 100%; height: 2rem;line-height: 2rem;font-size: .26rem;color: #666;text-align: center;}
  .item-img input{ position: absolute; left: 0; top: 0;width: 100%;height: 100%; opacity: 0; }
  textarea{display:block;width:100%;height: 2rem;margin-top:.12rem;padding: .12rem .24rem;font: .26rem/.36rem "Microsoft YaHei";border-radius: .06rem;border: 1px solid #e3e3e3;resize: none;color:#333;}
  .alert-box{position:fixed;top:0;left:0;z-index: 12;width: 100%;height: 100%;}
  .alert-box .alert-con{position: absolute;left: 0;bottom: 0;width: 100%;min-height: 50vh;padding-bottom:1.4rem;background: #fff;border-radius: .28rem .28rem 0 0;overflow: hidden;}
  .alert-box .icon-close{position: absolute;top:.43rem;right:.4rem;width: .28rem;height: .28rem;padding: 0;}
  .alert-box .order-alert-top{padding-top:.3rem;padding-bottom: .2rem;border-bottom: 1px solid #e3e3e3;}
  .alert-box .t1{padding-left: .3rem;font-size: .32rem;color: #222;}
  .alert-box .btn-box{position: absolute;bottom:0;left: 0;z-index:1;width: 100%;height: 1.2rem;padding: .2rem .24rem;background: #fff;border-top:1px solid #e3e3e3;}
  .alert-box .btn-box .btn{position: relative;width: 100%;height: .8rem;border-radius: .4rem;line-height: .8rem;}
  .alert-order .order-con{height: 100%;padding:.24rem .24rem 1.6rem;;overflow-y: scroll;}

  .time-list{padding: .2rem .24rem .32rem;}
  .time-list span{padding: 0 .2rem;height: .54rem;background: #f2f2f2;color: #333;border-radius: .27rem;font: .24rem/.54rem "Microsoft YaHei";margin-top: .12rem;margin-right: .12rem;}
  .time-list span.curr{background: #fd811e;color: #fff;}
  .menu{position: fixed;right: .12rem;bottom: 26%;z-index:12;width: 1rem;height: 1rem;font: .24rem/.34rem "Microsoft YaHei";color: #fff;border-radius: 50%;text-align: center;padding: .16rem 0;background: #fd811e;box-shadow: 0 0 .24rem rgba(0,0,0,.1);}
  .date-alert .alert-con{height: 40vh;padding-top: 20%;min-height: inherit;padding-bottom: 1rem;}
  .top-btn{position: absolute;top:0;left: 0;z-index:1;width: 100%;height: .82rem;background: #fff;font-size: .28rem;color: #333;line-height: .82rem;border-bottom: 1px solid #e8e8e8;}
  .top-btn .fl{margin-left: .24rem;}
  .top-btn .fr{color: #0b97c4;margin-right: .24rem;}
  .date-list{height: 100%;overflow-y: scroll;}
  .date-list .item{margin-top:0;text-align: center;font: .26rem/.56rem "Microsoft YaHei";color: #666;border-bottom: 1px solid #f3f3f3;}

  .item-inp1{ padding: 0 .17rem; border: none; background: #fff;}
  .item-inp1 .radio{ display: inline-block;height: .62rem; line-height: .62rem;color: #333;  margin-right: .65rem;padding-left: .6rem;background: url(../../assets/check.png) no-repeat left center;background-size: .46rem .46rem;}
  .item-inp1 .radio.curr{background: url(../../assets/check-curr.png) no-repeat left center;background-size: .46rem .46rem;}
</style>



// WEBPACK FOOTER //
// src/page/home/order-team.vue